import { FIXED_KEYS_DOUBLE } from '@framework/workbench/schema/constant';
import { WorkbenchToolbarSchema } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import {
    COMMON_BEAUTIFY_END_GROUP,
    COMMON_INSERT_DOUBLE_GROUP, COMMON_SIMPLE_DATA, COMMON_TAB_ANIM_DOUBLE_DATA, COMMON_TAB_BEAUTIFY_DOUBLE_DATA,
    COMMON_TAB_INSERT_DOUBLE_DATA, COMMON_TAB_PLAY_DOUBLE_DATA,
    COMMON_TAB_START_DOUBLE_DATA, COMMON_TAB_VIEW_DOUBLE_DATA,
} from '@framework/workbench/schema/toolbar-schema/common';
import {
    wrapIdForBig,
    wrapIdForCommon,
    wrapIdForInput,
    wrapIdForPic,
    wrapIdForTableTabInput,
    wrapIdForTextTab,
    wrapIdForVip,
} from '@framework/workbench/util/wrap-id-util';
import { ActionType, ChildActionType } from '@editor/src/js/constants/common-action-type';
import { FOLD_ICON_TYPE } from '@src/framework/workbench/ui/fold/config';

export const TOOLBAR_SCHEMA: WorkbenchToolbarSchema = {
    [FIXED_KEYS_DOUBLE.TOOLBAR_START]: {
        data: [
            ...COMMON_TAB_START_DOUBLE_DATA,
            [wrapIdForBig(ActionType.QUICK_TOOL)],
            [wrapIdForBig(ActionType.PAGE_SETTING)],
            [
                {
                    shelter: wrapIdForBig(`${ActionType.PDF_TRANSFORM}-parent`),
                    buttons: [
                        [
                            wrapIdForBig(ActionType.PDF_TRANSFORM),
                            wrapIdForBig(ActionType.FILE_COMPRESSION),
                            wrapIdForBig(ActionType.EXPORT_IMAGE),
                        ],
                    ],
                },
            ],
            [wrapIdForBig(ActionType.INTELLIGENT_TOOL)],
            [wrapIdForBig(ActionType.PRINT)],
            [ActionType.EXIT_MASTER_EDIT],
        ],
        moreText: i18n.t('更多'),
        moreTooltip: i18n.t('更多'),
        label: i18n.t('开始'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_INSERT]: {
        data: [
            ...COMMON_TAB_INSERT_DOUBLE_DATA,
            [
                ...COMMON_INSERT_DOUBLE_GROUP,
            ],
            [ActionType.INSERT_TENCENT_DOC_ID, ActionType.UPLOAD_LOCAL_FILE],
            [ActionType.INSERT_IFRAME],
            [wrapIdForBig(ActionType.INSERT_COMMENT)],
        ],
        label: i18n.t('插入'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_ANIM]: {
        data: [
            ...COMMON_TAB_ANIM_DOUBLE_DATA,
        ],
        label: i18n.t('动画'),
        moreText: i18n.t('更多'),
        moreTooltip: i18n.t('更多'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_VIEW]: {
        data: [
            ...COMMON_TAB_VIEW_DOUBLE_DATA,
            [ActionType.EXIT_MASTER_EDIT],
        ],
        label: i18n.t('视图'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_BEAUTIFY]: {
        data: [
            ...COMMON_TAB_BEAUTIFY_DOUBLE_DATA,
            [
                ActionType.LAYOUT_SUGGESTION_TOOLBAR,
                ActionType.UNIFORM_FONT_TOOLBAR,
                ActionType.PIC_HANDLE_TOOLBAR,
            ],
            COMMON_BEAUTIFY_END_GROUP,
        ],
        label: i18n.t('美化'),
        moreTooltip: i18n.t('更多'),
        moreText: i18n.t('更多'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_TRANSITION]: {
        data: [
            [ActionType.TRANSITION_PREVIEW],
            [
                ActionType.TRANSITION_CHANGE,
                ActionType.TRANSITION_EFFECT_TOOLBAR,
            ],
            [
                ActionType.TRANSITION_DURATION,
            ],
            [ActionType.TRANSITION_APPLY_ALL],
        ],
        label: i18n.t('切页'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_EFFICIENCY]: {
        data: [
            [wrapIdForBig(ActionType.MUTI_PICTURE_EXPORT)],
            {
                shelter: wrapIdForBig(`${ActionType.PDF_TRANSFORM}-parent`),
                items: [[[
                    wrapIdForBig(ActionType.PDF_TRANSFORM),
                    wrapIdForBig(ActionType.FILE_COMPRESSION),
                    wrapIdForBig(ActionType.EXPORT_IMAGE),
                ]]],
            },
            [wrapIdForBig(ActionType.INTELLIGENT_TOOL)],
        ],
        label: i18n.t('效率工具'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_PLAY]: {
        data: [
            ...COMMON_TAB_PLAY_DOUBLE_DATA,
            [ActionType.LOCAL_WITH_PRESENTER_VIEW, ActionType.MOBILE_REMOTE_PLAY],
            [ActionType.REMOTE_PLAY, ActionType.TENCENT_MEETING_PLAY],
        ],
        label: i18n.t('放映'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_COMMENT]: {
        data: [
            [
                ActionType.INSERT_COMMENT,
                ActionType.DELETE_COMMENT,
                ActionType.JUMP_TO_PREV_COMMENT,
                ActionType.JUMP_TO_NEXT_COMMENT,
            ],
            {
                items: [
                    [[ActionType.SHOW_COMMENT]],
                    [
                        [ActionType.SHOW_COMMENT_ANCHOR],
                        [ActionType.SHOW_COMMENT_NOTIFY_FLAG],
                    ],
                ],
            },
            [
                ActionType.AI_REVIEW,
            ],
        ],
        label: i18n.t('审阅'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_TABLE]: {
        data: [
            {
                items: [
                    [
                        [ActionType.UNDO],
                        [ActionType.REDO],
                    ],
                    wrapIdForBig(ActionType.FORMAT_BRUSH),
                ],
            },
            [ActionType.TABLE_STYLE_PANEL],
            [
                ActionType.TABLE_QUICK_SETTING,
                [
                    [ActionType.FILLCOLOR],
                    [ActionType.MERGE_CELL_TOOLBAR],
                ],
            ],
            {
                items: [
                    [
                        [wrapIdForTableTabInput(ActionType.BORDERSTYLE), ActionType.BORDER_STYLE_TOOLBAR],
                        [wrapIdForTableTabInput(ActionType.BORDERCOLOR),  ActionType.BORDER_WIDTH_TOOLBAR],
                    ],
                ],
            },
            {
                items: [
                    [
                        [
                            wrapIdForTableTabInput(ActionType.FONT),
                            wrapIdForInput(ActionType.FONTSIZE),
                            ActionType.FORECOLOR,
                            ActionType.FONT_EFFECT_TOOLBAR,
                            ActionType.FONT_BORDER_TOOLBAR,
                        ],
                        [
                            ActionType.BOLD,
                            ActionType.ITALIC,
                            ActionType.UNDERLINE,
                            ActionType.DELETELINE,
                            ActionType.ITEMNUMBER,
                            ActionType.DIGITNUMBER,
                            ActionType.HORIZONTAL_ALIGN,
                            ActionType.VERTICAL_ALIGN,
                        ],
                    ],
                ],
            },
        ],
        label: i18n.t('表格样式'),
        moreTooltip: i18n.t('更多'),
        moreText: i18n.t('更多'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_TABLE_POSITION]: {
        data: [
            {
                items: [
                    [
                        [ActionType.UNDO],
                        [ActionType.REDO],
                    ],
                ],
            },
            {
                items: [
                    ActionType.DELETE_TABLE_TOOLBAR,
                    [
                        [ActionType.INSERT_TOP_TOOLBAR, ActionType.INSERT_LEFT_TOOLBAR],
                        [ActionType.INSERT_BOTTOM_TOOLBAR, ActionType.INSERT_RIGHT_TOOLBAR],
                    ],
                ],
            },
            {
                items: [
                    [
                        [ActionType.MERGE_CELL_TOOLBAR_TEXT],
                        [ActionType.CANCEL_CELL_TOOLBAR_TEXT],
                    ],
                ],
            },
            {
                items: [
                    [
                        [ActionType.TABLE_ROW_HEIGHT_TOOLBAR],
                        [ActionType.TABLE_COL_WIDTH_TOOLBAR],
                    ],
                    [
                        [ActionType.TABLE_SHARING_ROW],
                        [ActionType.TABLE_SHARING_COL],
                    ],
                ],
            },
            {
                items: [
                    ActionType.TABLE_FONT_MARGIN,
                    ActionType.TABLE_FONT_DIRECTION,
                ],
            },
            {
                items: [
                    wrapIdForBig(ChildActionType.ALIGN),
                    [
                        [ActionType.MOVEUP],
                        [ActionType.MOVEDOWN],
                    ],
                ],
            },
        ],
        label: i18n.t('表格布局'),
        moreTooltip: i18n.t('更多特权'),
        moreText: i18n.t('更多特权'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_VIP]: {
        data: [
            {
                items: [
                    ActionType.VIP_CENTER,
                ],
            },
            {
                items: [
                    wrapIdForBig(ActionType.EXPORT_IMAGE),
                    wrapIdForBig(ActionType.PDF_TRANSFORM),
                    // ActionType.CHANGE_THEME,
                    ActionType.UNIFORM_FONT_TOOLBAR,
                ],
            },
            {
                items: [
                    [
                        [wrapIdForVip(ActionType.MUTI_PICTURE_EXPORT),
                            wrapIdForVip(ActionType.MUTI_PICTURE_POS_SETTING)],
                        [wrapIdForVip(ActionType.MUTI_PICTURE_SIZE_SETTING),
                            wrapIdForVip(ActionType.OCR_PICTURE)],
                    ],
                ],
            },
            {
                items: [
                    ActionType.CHANGE_TEMPLATE_CONTENT,
                    ActionType.CHANGE_TEMPLATE_MORE,
                ],
            },
        ],
        label: i18n.t('会员专享'),
        moreTooltip: i18n.t('更多'),
        moreText: i18n.t('更多'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_SHAPE]: {
        data: [
            {
                items: [
                    [
                        [ActionType.UNDO],
                        [ActionType.REDO],
                    ],
                    wrapIdForBig(ActionType.FORMAT_BRUSH),
                ],
            },
            {
                items: [
                    wrapIdForBig(ActionType.INSERT_TEXT),
                    wrapIdForBig(ActionType.INSERT_SHAPE),
                ],
            },
            {
                items: [
                    ActionType.SHAPE_FAST_STYLE,
                    wrapIdForCommon(ActionType.FILLCOLOR),
                    wrapIdForCommon(ActionType.BORDERCOLOR),
                    wrapIdForCommon(ActionType.EFFECT),
                ],
            },
            {
                items: [
                    ActionType.TEXT_FAST_STYLE,
                    [
                        [wrapIdForTextTab(ActionType.FORECOLOR)],
                        [wrapIdForTextTab(ActionType.EFFECT)],
                    ],
                    {
                        shelter: wrapIdForBig(FOLD_ICON_TYPE.FONT_SETTING),
                        buttons: [
                            [
                                wrapIdForTextTab(ActionType.FONT),
                                wrapIdForInput(ActionType.FONTSIZE),
                                ActionType.FONTSIZE_UP,
                                ActionType.FONTSIZE_DOWN,
                                ActionType.FONT_BORDER_TOOLBAR,
                                ActionType.BACKCOLOR,
                            ],
                            [
                                ActionType.BOLD,
                                ActionType.ITALIC,
                                ActionType.UNDERLINE,
                                ActionType.DELETELINE,
                                ActionType.ITEMNUMBER,
                                ActionType.DIGITNUMBER,
                                ActionType.HORIZONTAL_ALIGN,
                                ActionType.VERTICAL_ALIGN,
                            ],
                        ],
                    },
                ],
            },
            {
                items: [
                    [
                        [
                            ActionType.ROTATE,
                            wrapIdForCommon(ActionType.MOVEUP),
                            wrapIdForCommon(ActionType.GROUP),
                        ],
                        [
                            wrapIdForCommon(ChildActionType.ALIGN),
                            wrapIdForCommon(ActionType.MOVEDOWN),
                            ActionType.SELECT_WINDOW,
                        ],
                    ],
                ],
            },
            {
                items: [
                    ActionType.SIZE_WITH_RATIO,
                ],
            },
        ],
        label: i18n.t('形状'),
        moreTooltip: i18n.t('更多'),
        moreText: i18n.t('更多'),
    },
    [FIXED_KEYS_DOUBLE.TOOLBAR_PICTURE]: {
        data: [
            {
                items: [
                    [
                        [ActionType.UNDO, wrapIdForPic(ActionType.REPLACE_PICTURE)],
                        [ActionType.REDO, wrapIdForPic(ActionType.RESET_PICTURE)],
                    ],
                ],
            },
            {
                items: [
                    ActionType.PICTURE_FAST_STYLE,
                    wrapIdForPic(ActionType.EFFECT),
                    [
                        [
                            wrapIdForCommon(ActionType.FILLCOLOR),
                            wrapIdForPic(ActionType.PICTURE_CORRECTIONS),
                            wrapIdForPic(ActionType.PICTURE_TRANSPARENCY),
                        ],
                        [
                            wrapIdForPic(ActionType.BORDERCOLOR),
                            wrapIdForPic(ActionType.PICTURE_COLOR),
                        ],
                    ],
                ],
            },
            {
                items: [
                    [
                        [
                            ActionType.ROTATE,
                            wrapIdForCommon(ActionType.MOVEUP),
                            wrapIdForCommon(ActionType.GROUP),
                        ],
                        [
                            wrapIdForCommon(ChildActionType.ALIGN),
                            wrapIdForCommon(ActionType.MOVEDOWN),
                            ActionType.SELECT_WINDOW,
                        ],
                    ],
                ],
            },
            {
                items: [
                    wrapIdForBig(ActionType.TAILOR_PIC),
                    ActionType.SIZE_WITH_RATIO,
                    ActionType.CROP_TO_SHAPE,
                    wrapIdForBig(ActionType.TAILOR_PIC_WH),
                    wrapIdForPic(ActionType.PIC_HANDLE_TOOLBAR),
                ],
            },
            {
                items: [
                    wrapIdForCommon(ActionType.INTELLIGENT_TOOL),
                ],
            },
        ],
        label: i18n.t('图片'),
        moreTooltip: i18n.t('更多'),
        moreText: i18n.t('更多'),
    },
    // 这里的内容通过组件动态拉取, 一开始给空就行
    [FIXED_KEYS_DOUBLE.TOOLBAR_MACHINE_AUDIT]: {
        data: [],
    },
    'toolbar-pinned': {
        data: [[ActionType.SEARCH_REPLACE, ActionType.TOOLBAR_MODE]],
    },
    'toolbar-simple': {
        moreTooltip: i18n.t('更多'),
        data: [
            ...COMMON_SIMPLE_DATA,
            [ActionType.QUICK_TOOL],
            [ActionType.PAGE_SETTING],
            [ActionType.PDF_TRANSFORM, ActionType.EXPORT_IMAGE, ActionType.FILE_COMPRESSION],
            [ActionType.INTELLIGENT_TOOL],
            [ActionType.PRINT],
        ],
    },
};
